import { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { authApi } from '../api';
import { useAuth } from '../contexts/AuthContext';
import AuthLayout from '../components/layout/AuthLayout';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const { loginWithToken } = useAuth();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const r = await authApi.login({ email, password });
      await loginWithToken(r.token, r.tenant_id);
      const to = (loc.state as { from?: { pathname: string } } | null)?.from?.pathname || '/';
      nav(to, { replace: true });
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      heading="Welcome back"
      subheading="Sign in to your chambers account to continue."
    >
      <form className="card stack" onSubmit={submit} style={{ gap: 14 }}>
        <div>
          <label htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            autoComplete="email"
            placeholder="you@chambers.co.za"
          />
        </div>
        <div>
          <label htmlFor="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            placeholder="••••••••"
          />
        </div>
        {error && (
          <div
            style={{
              padding: '10px 12px',
              borderRadius: 'var(--radius)',
              background: 'var(--color-danger-soft)',
              border: '1px solid rgba(229, 85, 60, 0.35)',
              color: 'var(--color-danger)',
              fontSize: 13,
            }}
          >
            {error}
          </div>
        )}
        <button type="submit" className="primary" disabled={submitting} style={{ marginTop: 4 }}>
          {submitting ? 'Signing in…' : 'Sign in'}
        </button>
      </form>

      <p style={{ marginTop: 18, fontSize: 13, color: 'var(--color-text-muted)' }}>
        Don't have an account?{' '}
        <Link to="/signup" style={{ color: 'var(--color-accent)', fontWeight: 500 }}>
          Start a 30-day trial
        </Link>
      </p>
    </AuthLayout>
  );
}
